import React from 'react';
import { Text, Group, ActionIcon } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { IconTrash } from '@tabler/icons-react';
import { formatFileSize } from '@/utils/fileValidation';
import { FileTypeIcon } from '@/components/common/FileTypeIcon';
import { ICON_SIZE_LG } from '@/constants/ui';
import type { FilePreviewProps } from './FileUpload.types';
import styles from './FileUpload.module.css';

export const FilePreview = React.memo<FilePreviewProps>(
  ({ file, onRemove, disabled = false }) => {
    const { t } = useTranslation();

    return (
      <div className={styles.fileItem}>
        <Group gap="sm" className={styles.fileItemContent}>
          <div className={styles.fileIcon}>
            <FileTypeIcon
              name={file.name}
              mimeType={file.type}
              size={ICON_SIZE_LG}
            />
          </div>

          <div className={styles.fileDetails}>
            <Text
              size="sm"
              fw={500}
              className={styles.fileName}
              title={file.name}
            >
              {file.name}
            </Text>
            <Text size="xs" c="dimmed">
              {formatFileSize(file.size)}
            </Text>
          </div>

          <ActionIcon
            variant="subtle"
            color="red"
            size="sm"
            onClick={onRemove}
            disabled={disabled}
            className={styles.deleteButton}
            aria-label={t('fileUpload.removeFileLabel', {
              fileName: file.name,
              defaultValue: 'Remove {{fileName}}',
            })}
          >
            <IconTrash size={16} />
          </ActionIcon>
        </Group>
      </div>
    );
  }
);

FilePreview.displayName = 'FilePreview';
